import { EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'
import { ContactFragment } from 'generated/resources/graphql'

import { contactFullName } from 'modules/finance/lib/contactsUtils'

export function mapToFinanceContactFragment(
  selected: EntitySelectEntity,
  available: ContactFragment[]
): ContactFragment {
  const entity = available.find((a) => a.id === selected.id)

  // This should never happen
  if (!entity) {
    throw new Error('Contact not found')
  }

  return {
    __typename: 'FinanceContact',
    id: String(entity.id),
    name: entity.name,
    legalName: entity.legalName,
    taxId: entity.taxId,
    address: entity.address,
    companyId: entity.companyId,
    bankCode: entity.bankCode,
    iban: entity.iban,
    preferredPaymentMethod: entity.preferredPaymentMethod,
  }
}

export function mapFinanceContacts(financeContacts: ContactFragment[]): EntitySelectEntity[] {
  return financeContacts.map((element) => {
    return {
      id: element.id,
      name: contactFullName(element),
      searchKey: [element.name, element.legalName],
    }
  })
}

export function mapSelectedFinanceContacts(
  selectedFinanceContacts: ContactFragment[],
  financeContactEntities: EntitySelectEntity[]
): EntitySelectEntity[] {
  return financeContactEntities.filter((financeContact) =>
    selectedFinanceContacts.find(
      (selectedFinanceContact) => selectedFinanceContact.id == financeContact.id
    )
  )
}
